export const ReferenceDetailSkeleton = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading reference"
    className="h-full flex-1 overflow-auto bg-neutral-200 px-9 py-8"
  >
    <div className="mx-auto flex min-h-[1056px] w-[816px] flex-col bg-white font-sans shadow-sm">
      {/* Confidential header */}
      <div className="flex items-center justify-between border-b border-zinc-300 px-6 pt-6 pb-3">
        <div className="h-3 w-80 animate-pulse rounded bg-neutral-200" />
        <div className="h-5 w-16 animate-pulse rounded bg-neutral-200" />
      </div>

      {/* Title + patient details */}
      <section className="flex flex-col gap-4 bg-gray-100 px-8 pt-8 pb-5">
        <div className="h-8 w-72 animate-pulse rounded bg-neutral-200" />
        <div className="flex flex-col gap-4 rounded-sm border border-slate-200 bg-white py-4">
          <div className="px-3">
            <div className="h-3 w-24 animate-pulse rounded bg-neutral-200" />
          </div>
          <div className="h-px w-full bg-zinc-300" />
          <div className="flex flex-col gap-4 px-6">
            <div className="flex gap-2">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={`patient-top-${index}`}
                  className="flex flex-1 flex-col gap-1.5"
                >
                  <div className="h-3 w-16 animate-pulse rounded bg-neutral-200" />
                  <div className="h-3 w-28 animate-pulse rounded bg-neutral-100" />
                </div>
              ))}
            </div>
            <div className="flex gap-2">
              {Array.from({ length: 2 }).map((_, index) => (
                <div
                  key={`patient-bottom-${index}`}
                  className="flex flex-1 flex-col gap-1.5"
                >
                  <div className="h-3 w-16 animate-pulse rounded bg-neutral-200" />
                  <div className="h-3 w-40 animate-pulse rounded bg-neutral-100" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="flex flex-1 flex-col gap-4 px-8 py-5">
        {/* Summary cards */}
        <div className="grid grid-cols-2 gap-4">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={`summary-card-${index}`}
              className="overflow-hidden rounded-sm border border-slate-200 bg-white"
            >
              <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
                <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
                <div className="size-5 animate-pulse rounded-full bg-neutral-200" />
              </div>
              <div className="space-y-2 px-4 py-3">
                <div className="h-3 w-40 animate-pulse rounded bg-neutral-100" />
                <div className="h-3 w-28 animate-pulse rounded bg-neutral-100" />
              </div>
            </div>
          ))}
        </div>

        {/* Detail panel */}
        <div className="overflow-hidden rounded-sm border border-slate-200 bg-white">
          <div className="space-y-2 bg-slate-700 px-4 py-3">
            <div className="h-4 w-36 animate-pulse rounded bg-slate-500" />
            <div className="h-3 w-48 animate-pulse rounded bg-slate-500" />
          </div>

          <div className="grid grid-cols-2 gap-4 bg-slate-100 px-4 py-3">
            {Array.from({ length: 2 }).map((_, index) => (
              <div key={`meta-block-${index}`} className="space-y-2">
                <div className="h-3 w-20 animate-pulse rounded bg-neutral-200" />
                {Array.from({ length: 4 }).map((_, rowIndex) => (
                  <div
                    key={`meta-row-${index}-${rowIndex}`}
                    className="h-3 w-full max-w-[12rem] animate-pulse rounded bg-neutral-100"
                  />
                ))}
              </div>
            ))}
          </div>

          <div className="space-y-2 border-t border-slate-200 bg-slate-100 px-4 py-3">
            <div className="h-3 w-16 animate-pulse rounded bg-neutral-200" />
            <div className="h-3 w-44 animate-pulse rounded bg-neutral-100" />
            <div className="h-3 w-56 animate-pulse rounded bg-neutral-100" />
          </div>

          <div className="border-t border-slate-200">
            <div className="grid grid-cols-7 gap-3 bg-zinc-100 px-4 py-2.5">
              {Array.from({ length: 7 }).map((_, index) => (
                <div
                  key={`table-header-${index}`}
                  className="h-3 animate-pulse rounded bg-neutral-200"
                />
              ))}
            </div>
            {Array.from({ length: 2 }).map((_, rowIndex) => (
              <div
                key={`table-row-${rowIndex}`}
                className="grid grid-cols-7 gap-3 border-t border-slate-100 px-4 py-3"
              >
                {Array.from({ length: 7 }).map((_, colIndex) => (
                  <div
                    key={`table-cell-${rowIndex}-${colIndex}`}
                    className="h-3 animate-pulse rounded bg-neutral-100"
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <span className="sr-only">Loading reference...</span>
  </div>
);
